export default class CKEditorInput {
	constructor() {
		this.editors = {};
	}

	addEditor(instanceId, instance) {
		this.editors[instanceId] = instance;
	}

	setCKReadonly(inProcess) {
		Object.entries(this.editors).forEach(([key, value]) => {
			this.editors[key].editorInstance.setReadOnly(inProcess);
		});
	}
}



// WEBPACK FOOTER //
// ./src/utils/forms/CKEditorInput.js